import { Config } from '../config/env';

const { tenantId } = Config;

export const URL = {
  LIBRARY_TAGS: `v1/library/${tenantId}/tags`,
  LIBRARY_RESOURCES: `v1/library/${tenantId}/resources`,
  LIBRARY_CATEGORIES: `v1/library/${tenantId}/categories`,
  LIBRARY_RESOURCE_DETAILS: `v1/library/${tenantId}/resources/:id`,
};
